import HtmlBuilder from '../class/HtmlBuilder';
class SelectField {
    constructor(label, options, value) {
        this._label = label;
        this._select = SelectField.createElement(value);
        this.changeOptions(options);
        this._block = HtmlBuilder.createBlock(label, this._select);
    }
    get label() {
        return this._label;
    }
    set label(label) {
        this._label = HtmlBuilder.updateLabel(this._block, label);
    }
    get value() {
        return this._select.value;
    }
    get block() {
        return this._block;
    }
    set value(value) {
        this._select.value = value;
        this.nice('update');
        $(this._select).trigger('change');
    }
    nice(ev) {
        $(this._select).niceSelect(ev);
    }
    remove() {
        $(this._select).niceSelect('destroy');
        this.block.remove();
    }
    changeOptions(options) {
        this._select.innerHTML = '';
        this._select.append(...SelectField.changeOptions(options));
        $(this._select).niceSelect('update');
    }
    onChange(cb) {
        $(this._select).on('change', cb);
    }
    static createElement(value) {
        const select = document.createElement('select');
        select.classList.add('calcZV__select');
        if (value)
            select.value = value;
        return select;
    }
    static findNiceElement(select) {
        return $(select).parents('.calcZV__block-label').find('.nice-select.calcZV__select');
    }
    static changeOptions(options) {
        const optList = [];
        for (const opt of options) {
            const optEl = document.createElement('option');
            if (typeof opt === 'string') {
                optEl.textContent = opt;
                optEl.value = opt;
            }
            else {
                optEl.textContent = opt.label;
                optEl.value = opt.value;
            }
            optList.push(optEl);
        }
        return optList;
    }
    static getOptions(select) {
        return [...select.querySelectorAll('option')].map(it => it.value);
    }
}
export default SelectField;
